import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Checkbox, Select, Tooltip, InputNumber, Input, AutoComplete, Spin, Collapse } from 'antd'
import TagsInput from '@/components/TagsInput';
import { CloseCircleFilled } from '@ant-design/icons';
import { CUSTOM, INTERFACE_TYPE_LIST } from '../../../../services/PCBHelper/constants';
import { getDefaultName } from '../../../../services/helper/setDefaultName';
import { checkNameFormat } from '../../../../services/helper/nameFormatCheck';
import { getCustomInterfacesLibrary, saveCustomInterfacesLibraryPromise } from '../../../../services/Sierra/library';
import { CUSTOM_GPIO_DEFINITION } from '../../../../constants/libraryConstants';
import sierraLibrary from '../../../../services/Sierra/library/libraryStorage';
import { SIGNAL_CLK, SIGNAL_DATA } from '../../../../services/Sierra/helper/tableHelper';
import { defaultCustomConfig } from '../../../../services/Sierra/helper/InterfaceHelper';
import { saveCustomInterfacesLibrary } from '../../store/library/action';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import _ from "lodash";
import './index.css';

const signalColumns = [{
  key: "name",
  title: "Signal Name"
},
{
  key: "keywords",
  title: "Keywords"
},
{
  key: "signalType",
  title: "Signal Type"
}]
class CustomInterfacesDefinition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      libraryId: null,
      config: {},
      errorMsg: null,
      getLoading: false,
      libraryList: sierraLibrary.getTree(CUSTOM_GPIO_DEFINITION),
      saveToLibrary: true
    }
  }

  initConfig = (advancedConfig, isUpdate, isFirstInit) => {
    const contentConfig = advancedConfig && advancedConfig.config && Object.keys(advancedConfig.config).length ? advancedConfig.config : null;
    let config = contentConfig ? JSON.parse(JSON.stringify(contentConfig)) : new defaultCustomConfig(CUSTOM, { signalNumber: 1 });
    //add inputName to signal name
    if (config.signalDefinitions && config.signalDefinitions.length) {
      config.signalDefinitions.forEach(item => {
        item.inputName = item.name;
      })
    }
    if (isUpdate) {
      const { name, id } = advancedConfig;
      const libraryList = sierraLibrary.getTree(CUSTOM_GPIO_DEFINITION);
      this.setState({
        config,
        libraryId: id || null,
        libraryList,
        name: name ? name : isFirstInit ? getDefaultName({ nameList: libraryList.map(item => item.name), defaultKey: "Custom", delimiter: "", key: "", firstIndex: 1 }) : name,
      })
    }
    return config;
  }

  componentDidMount = () => {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
    this.initConfig(this.props.advancedConfig, true, true)
  }

  componentDidUpdate = (prevProps) => {
    const { loading, libraryTreeInfo, updatePCBList } = this.props;
    if (prevProps.loading !== loading && !loading) {
      this.initConfig(this.props.advancedConfig, true)
    }

    if (updatePCBList && updatePCBList.length && !prevProps.updatePCBList.length) {
      this.initConfig(this.props.advancedConfig, true)
      this.props.updateApplyAllPCBList([])
    }

    if (libraryTreeInfo
      && libraryTreeInfo.length && libraryTreeInfo.includes(CUSTOM_GPIO_DEFINITION)
      && (!prevProps.libraryTreeInfo || libraryTreeInfo.length !== prevProps.libraryTreeInfo.length
        || !_.isEqual(prevProps.libraryTreeInfo, libraryTreeInfo)
      )
    ) {
      this.setState({
        libraryList: sierraLibrary.getTree(CUSTOM_GPIO_DEFINITION)
      })
    }
  }

  /*   getConfig = () => {
      const { config, libraryId, name } = this.state;
      return { config, libraryId, name }
    } */

  saveConfig = async () => {
    const { config, libraryId, name, saveToLibrary, errorMsg } = this.state;
    if (!saveToLibrary || errorMsg) {
      return;
    }
    let newConfig = JSON.parse(JSON.stringify(config));
    let _config = { ...config };
    (newConfig.signalDefinitions || []).forEach(item => {
      //remove input value for UI
      delete item.inputName
    })
    delete newConfig.type; //CUSTOM
    delete newConfig.id;
    delete newConfig.name;
    try {
      const res = await saveCustomInterfacesLibraryPromise({ id: libraryId || null, name, definition: newConfig });
      _config.id = res.id;
      this.setState({
        config: _config,
        libraryId: res.id
      }, () => {
        this.updateAdvancedConfigToProps(_config)
      })
    } catch (error) {
      console.error(error)
    }
    this.props._saveCustomInterfacesLibrary({ id: libraryId || null, name, definition: newConfig }, true)
  }

  checkChange = (e, type) => {
    const config = { ...this.state.config, [type]: e.target.checked };
    this.setState({
      config
    })
    this.updateAdvancedConfigToProps(config)
  }

  numberValueChange = (value, type) => {
    let _config = this.state.config;
    if (type === "signalNumber") {
      const prevNumber = _config.signalNumber || 0;
      if (!_config.signalDefinitions) {
        _config.signalDefinitions = []
      }
      const signalNames = _config.signalDefinitions.map(it => it.name);
      if (value > prevNumber) {
        const newNum = value - prevNumber;
        _config.signalDefinitions.push(...Array(newNum).keys().map(item => {
          const name = getDefaultName({ nameList: signalNames, defaultKey: "Signal", delimiter: "", key: "", firstIndex: 1 });
          signalNames.push(name)
          return {
            name,
            inputName: name,
            keywords: [],
            isRegular: false,
            signalType: ""
          }
        }))
      } else {
        _config.signalDefinitions = _config.signalDefinitions.filter((item, index) => index < value);
      }
    }
    const config = { ..._config, [type]: value }
    this.setState({
      config
    })
    this.updateAdvancedConfigToProps(config)
  }

  updateAdvancedConfigToProps = (config) => {
    if (this.props.updateAdvancedConfig) {
      const { name, libraryId } = this.state;
      this.props.updateAdvancedConfig({ ...config, name, id: libraryId });
    }
  }

  changeTagList = (type, list, sigItem) => {
    if (type === "netNameKeywords") {
      this.setState({
        config: { ...this.state.config, [type]: list }
      })
      this.updateAdvancedConfigToProps({ ...this.state.config, [type]: list })
      return;
    }

    let config = this.state.config;

    const index = config.signalDefinitions.findIndex(item => item.name === sigItem.name);
    if (index < 0) {
      return;
    }
    config.signalDefinitions[index][type] = list;
    this.setState({
      config
    })
    this.updateAdvancedConfigToProps(config)
  }

  clearAllKeywords = (e, type, sigItem) => {
    e && e.stopPropagation()
    let config = this.state.config;
    if (sigItem) {
      const index = config.signalDefinitions.findIndex(item => item.name === sigItem.name);
      if (index < 0) {
        return;
      }
      config.signalDefinitions[index][type] = [];
      this.setState({
        config
      })
      this.updateAdvancedConfigToProps(config)
      return;
    }
    this.setState({
      config: { ...config, [type]: [] }
    })
    this.updateAdvancedConfigToProps({ ...config, [type]: [] })
  }

  updateRegularValue = (isRegular, type, sigItem) => {
    let config = this.state.config;
    if (sigItem) {

      const index = config.signalDefinitions.findIndex(item => item.name === sigItem.name);
      if (index < 0) {
        return;
      }
      config.signalDefinitions[index].isRegular = isRegular;
      config.signalDefinitions[index][type] = [];
      this.setState({
        config
      })
      this.updateAdvancedConfigToProps(config)
      return;
    }
    this.setState({
      config: { ...this.state.config, isRegular, [type]: [] }
    })
    this.updateAdvancedConfigToProps({ ...this.state.config, isRegular, [type]: [] })
  }

  selectValueChange = (value, type, sigItem) => {
    if (sigItem) {
      let config = this.state.config;

      const index = config.signalDefinitions.findIndex(item => item.name === sigItem.name);
      if (index < 0) {
        return;
      }
      config.signalDefinitions[index][type] = value;
      this.setState({
        config
      })
      this.updateAdvancedConfigToProps(config)
      return;
    }
    this.setState({
      config: { ...this.state.config, [type]: value }
    })
    this.updateAdvancedConfigToProps({ ...this.state.config, [type]: value })
  }

  inputChange = (e, type, sigItem) => {
    const value = e.target.value;
    const { config } = this.state;
    let _config = { ...config };

    const index = _config.signalDefinitions.findIndex(item => item.name === sigItem.name);
    if (index < 0) {
      return;
    }
    if (type === "name") {
      _config.signalDefinitions[index].inputName = value;
    }
    this.setState({
      config: _config
    })
  }

  inputBlur = (e, type, sigItem) => {
    const value = e.target.value;
    const { config } = this.state;
    let _config = { ...config };
    if (type === "name") {
      const index = _config.signalDefinitions.findIndex(item => item.name === sigItem.name);
      if (index < 0) {
        return;
      }
      const nameCheck = checkNameFormat(value, { errorType: "" });
      if (nameCheck) {
        _config.signalDefinitions[index].inputName = _config.signalDefinitions[index].name;
        this.setState({
          errorMsg: { type: "signalName", error: `${value} - Signal name ${nameCheck}.` },
          config: _config
        })
        this.clearErrorMsg()
        return
      }
      const names = _config.signalDefinitions.filter(it => it.name !== _config.signalDefinitions[index].name).map(it => it.name);
      if (names.includes(value)) {
        _config.signalDefinitions[index].inputName = _config.signalDefinitions[index].name;;
        this.setState({
          errorMsg: { type: "signalName", error: `${value} - Signal name must not be duplicated.` },
          config: _config
        })
        this.clearErrorMsg()
        return
      }

      _config.signalDefinitions[index].name = value;
      _config.signalDefinitions[index].inputName = value;
    }
    this.setState({
      config: _config
    })
    this.updateAdvancedConfigToProps(_config)
  }

  onPressEnter = (e, type, sigItem) => {
    this.inputBlur(e, type, sigItem);
  }

  onKeyDown = (e, type, sigItem) => {
    if (e.keyCode === 188) {
      this.inputBlur(e, type, sigItem);
    }
  }

  clearErrorMsg = () => {
    setTimeout(() => {
      this.setState({
        errorMsg: null
      })
    }, 2000)
  }

  changeCustomName = async (value) => {
    const { libraryList, errorMsg } = this.state;
    const { allowChangeLib } = this.props;
    const findLib = libraryList.find(item => item.name === value);
    if (findLib && allowChangeLib) {
      this.setState({
        name: findLib.name,
        libraryId: findLib.id,
        getLoading: true
      }, async () => {
        try {
          const definitionConfig = await getCustomInterfacesLibrary(findLib.id);
          const config = this.initConfig({ config: definitionConfig.definition });
          this.setState({
            config,
            getLoading: false,
            errorMsg: errorMsg && errorMsg.type === "name" ? null : errorMsg
          })
          this.updateAdvancedConfigToProps(config);
        } catch (error) {
          let message = "";

          if (error instanceof Error) {
            message = error.message;
            console.error(error)

          } else if (typeof error === "string") {
            message = error;
          } else {
            try {
              message = JSON.stringify(error); //  [object Object]
            } catch {
              message = String(error);
            }
          }
          this.setState({
            errorMsg: { type: "name", error: `Get ${findLib.name} config failed - ${message}` },
            getLoading: false,
            config: {}
          })
          this.updateAdvancedConfigToProps({});
        }
      })
      return
    }
    this.setState({
      name: value,
      libraryId: allowChangeLib ? null : this.state.libraryId,
      errorMsg: errorMsg && errorMsg.type === "name" ? null : errorMsg
    }, () => {
      this.updateAdvancedConfigToProps(this.state.config);
    })
  }

  saveName = () => {
    const { name, libraryList, errorMsg } = this.state;
    const findLib = libraryList.find(item => item.name === name);
    if (findLib) {
      return;
    }
    const error = checkNameFormat(name);
    if (error) {
      this.setState({
        errorMsg: { type: "name", error }
      })
    } else {
      this.setState({
        errorMsg: errorMsg && errorMsg.type === "name" ? null : errorMsg
      })
    }
  }

  onInputKeyDown = (e) => {
    if (e.keyCode === 188) {
      this.saveName();
    }
  }

  changeSaveToLibrary = (e) => {
    e.stopPropagation();
    this.setState({
      saveToLibrary: e.target.checked
    })
  }

  render = () => {
    const { saveToLibrary } = this.state;
    const { isSearch } = this.props;
    return isSearch ? <Collapse
      bordered={false}
      className='sierra-create-custom-interface-content'
      defaultActiveKey={["advanced"] || []}
      items={[
        {
          key: "advanced",
          label: <div className='sierra-custom-search-definition-collapse-title'>
            <span className='sierra-custom-search-definition-collapse-title-span'>Custom Search Criteria</span>
            <div className='sierra-custom-search-definition-collapse-checkbox' onClick={(e) => { e.stopPropagation() }}>
              <Checkbox
                checked={saveToLibrary}
                onChange={this.changeSaveToLibrary}>Save To Library</Checkbox>
            </div>
          </div>,
          children: this.collapseRender()
        }
      ]}
    /> : this.collapseRender()
  }

  collapseRender = () => {
    const { name, errorMsg, getLoading, libraryList } = this.state;
    const { allowChangeLib } = this.props;
    return <Fragment>
      <div className='sierra-custom-interfaces-definition-item'>
        <label>Custom Search Definition</label>
        {allowChangeLib ? <Tooltip
          title={`You can select a definition from the library or create a new one by simply entering a new name. Once you check "Save To Library" and click "OK", the definition will be automatically saved to the library.`}
        >
          <ExclamationCircleOutlined className='custom-interface-definition-info-icon' />
        </Tooltip> : null}
        <AutoComplete
          className='aurora-input'
          value={name}
          options={allowChangeLib ? (libraryList || []).map(item => { return { value: item.name, label: item.name } }) : []}
          //onSelect={this.selectCustomLib}
          onChange={this.changeCustomName}
          onBlur={this.saveName}
          onInputKeyDown={this.onInputKeyDown}
        />
      </div>
      <Spin tip="Loading Data..." spinning={getLoading}>
        {this.contentRender()}
      </Spin>
      {errorMsg && errorMsg.error ? <div className='aurora-model-name-error-msg'>{errorMsg.error}</div> : null}
    </Fragment>
  }

  getNetNamePrefixRender = ({ key, value, isRegular, sigItem, disabledRegular }) => {
    return <TagsInput
      type={key}
      tagList={value || []}
      changeTagList={(type, list) => this.changeTagList(type, list, sigItem)}
      className={isRegular ? 'sierra-select-regular-input' : 'sierra-not-select-regular-input'}
      isSuffix={!disabledRegular ? this.isSuffixIcon({ isRegular, showClose: value && value.length, inputKey: key, sigItem }) : null}
    />
  }

  isSuffixIcon = ({ isRegular, showClose, inputKey, sigItem }) => {
    return (
      <Fragment>
        {showClose ? <Tooltip
          classNames={{ root: 'aurora-tooltip' }}
          title={"Clear all"}
          key='nets-tooltip-clear-icon-input'>
          <CloseCircleFilled
            className="create-nets-keywords-clear-icon"
            onClick={(e) => this.clearAllKeywords(e, inputKey, sigItem)} />
        </Tooltip> : null}
        <Tooltip
          classNames={{ root: 'aurora-tooltip' }}
          title={isRegular ? "Regular Expression" : "Non Regular Expression"}
          key='icon-input'>
          <div
            onClick={() => this.updateRegularValue(!isRegular, inputKey, sigItem)}
            className={isRegular ? 'sierra-custom-regular-icon-selected' : 'regular-icon'}
          >.*</div>
        </Tooltip>
      </Fragment>
    );
  }


  getInterfaceTypeTitle = (interfaceType) => {
    if (interfaceType === CUSTOM) {
      return interfaceType
    }
    return <div>{interfaceType}-<span className='sierra-search-interface-type-title'>Custom</span></div>
  }

  contentRender = () => {
    const { config } = this.state;
    return <Fragment>
      <div className='sierra-custom-interfaces-definition-item'>
        <label>Interface Type</label>
        <Select
          onChange={(value) => this.selectValueChange(value, "interfaceType")}
          value={config.interfaceType}
          styles={{ popup: { root: { zIndex: 100000 } } }}
          showSearch={true}
          className='aurora-select'
          options={INTERFACE_TYPE_LIST.map(key => ({ value: key, label: this.getInterfaceTypeTitle(key), title: this.getInterfaceTypeTitle(key) }))}
        />
      </div>
      <div className='sierra-custom-interfaces-definition-item'>
        <label>Net Name Keywords</label>
        {this.getNetNamePrefixRender({ key: "netNameKeywords", value: config.netNameKeywords, isRegular: config.isRegular })}
      </div>
      <div
        className={`sierra-custom-interfaces-definition-item sierra-custom-interfaces-definition-item-checkbox`}>
        <Checkbox
          checked={config.allowVoltageKeywords}
          onChange={e => this.checkChange(e, "allowVoltageKeywords")}
        >
          Include net name with voltage keywords</Checkbox>
      </div>
      <div className='sierra-custom-interfaces-definition-item'>
        <label>Signal Number</label>
        <InputNumber
          min={1}
          className="aurora-input"
          placeholder="Signal Number"
          value={config.signalNumber}
          onChange={(value) => this.numberValueChange(value, 'signalNumber')}
        />
      </div>
      <div className='sierra-custom-interfaces-definition-signal-content'>
        <div className='sierra-custom-interfaces-definition-signal-row'>
          {signalColumns.map(item =>
            <div key={item.key} className={`sierra-custom-interfaces-definition-signal-row-title sierra-custom-interfaces-definition-signal-${item.key}-item`}>
              {item.title}
            </div>)}
        </div>
        {(config.signalDefinitions || []).map(sig =>
          <div key={sig.name} className='sierra-custom-interfaces-definition-signal-row'>
            {signalColumns.map(item =>
              <div key={`${sig.name}::${item.key}`} className={`sierra-custom-interfaces-definition-signal-item sierra-custom-interfaces-definition-signal-${item.key}-item`}>
                {this.getSignalItem(item, sig)}
              </div>)}
          </div>)}
      </div>
    </Fragment>
  }

  getSignalItem = (column, sigItem) => {
    if (column.key === "name") {
      return <Input
        className='sierra-custom-interfaces-definition-signal-input aurora-input'
        value={sigItem.inputName}
        onChange={(e) => this.inputChange(e, "name", sigItem)}
        onPressEnter={(e) => this.onPressEnter(e, "name", sigItem)}
        onBlur={(e) => this.inputBlur(e, "name", sigItem)}
        onKeyDown={(e) => this.onKeyDown(e, "name", sigItem)}
      />
    }

    if (column.key === "keywords") {
      return this.getNetNamePrefixRender({ key: "keywords", value: sigItem.keywords, isRegular: sigItem.isRegular, sigItem, disabledRegular: true })
    }

    if (column.key === "signalType") {
      return <Select
        onChange={(value) => this.selectValueChange(value, "signalType", sigItem)}
        value={sigItem.signalType}
        styles={{ popup: { root: { zIndex: 100000 } } }}
        showSearch={true}
        className='sierra-custom-interfaces-definition-signal-select aurora-select'
        options={[SIGNAL_CLK, SIGNAL_DATA].map(key => ({ value: key, label: key, title: key }))}
      />
    }
  }
}

const mapState = (state) => {
  const { SierraReducer: { library: { libraryTreeInfo } } } = state;
  return {
    libraryTreeInfo
  }
};

const mapDispatch = (dispatch) => ({
  _saveCustomInterfacesLibrary(data, isNotSave) {
    dispatch(saveCustomInterfacesLibrary(data, isNotSave))
  }
})

export default connect(mapState, mapDispatch)(CustomInterfacesDefinition);
